import React, { useEffect, useState } from "react";
import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";
import "./StationDashboard.css";

const AlertHistory = () => {
  const [alerts, setAlerts] = useState([]);
  const [selectedAlert, setSelectedAlert] = useState(null);
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyAFXkcBgPlixPN43xgMC1Bx9eY2k2HpyVQ",
  });

  useEffect(() => {
    fetch("https://senu-app.azurewebsites.net/api/alerts/all")
      .then(res => {
        if (!res.ok) throw new Error("Failed to fetch alerts");
        return res.json();
      })
      .then(data => setAlerts(data))
      .catch(err => console.error("Error fetching alerts:", err));
  }, []);

  return (
    <div style={{ padding: "20px" }}>
      <h2 style={{ textAlign: "center", marginBottom: "20px" }}>📜 Alert History</h2>

      {alerts.length === 0 ? (
        <p>No alerts found.</p>
      ) : (
        <ul style={{ maxHeight: "500px", overflowY: "auto", padding: 0 }}>
          {alerts.map(alert => (
            <li
              key={alert.id}
              onClick={() => setSelectedAlert(alert)}
              style={{
                padding: "10px",
                marginBottom: "8px",
                borderRadius: "6px",
                backgroundColor: alert.status === "Cancelled" ? "#F8D7DA" : "#D4EDDA",
                cursor: "pointer",
              }}
            >
              <div>{alert.message}</div>
              <div style={{ fontSize: "12px", color: "#555" }}>
                {new Date(alert.timestamp).toLocaleString()}
              </div>
            </li>
          ))}
        </ul>
      )}

      {selectedAlert && (
        <div style={{
          position: "fixed",
          top: 0, left: 0,
          width: "100vw", height: "100vh",
          backgroundColor: "rgba(0,0,0,0.6)",
          display: "flex", justifyContent: "center", alignItems: "center",
          zIndex: 1000
        }}>
          <div className="alert-modal" style={{
            backgroundColor: "white",
            borderRadius: "10px",
            width: "90%",
            maxWidth: "600px",
            padding: "20px",
            position: "relative",
            color: '#000000'
          }}>
            <button
              onClick={() => setSelectedAlert(null)}
              style={{ position: "absolute", top: "10px", right: "10px", cursor: "pointer", fontSize: "20px", border: "none", background: "none" }}
            >
              ✖
            </button>

            <h3 style={{ textAlign: "center" }}>Alert Details</h3>
            <p><strong>Status:</strong> {selectedAlert.status}</p>
            <p><strong>Message:</strong> {selectedAlert.message}</p>
            <p><strong>Location:</strong> {selectedAlert.latitude}, {selectedAlert.longitude}</p>
            <p><strong>Timestamp:</strong> {new Date(selectedAlert.timestamp).toLocaleString()}</p>
            <p><strong>User ID:</strong> {selectedAlert.userId}</p>

            {isLoaded && selectedAlert.latitude && selectedAlert.longitude && (
              <div style={{ height: "300px", width: "100%", marginTop: "15px" }}>
                <GoogleMap
                  mapContainerStyle={{ height: "100%", width: "100%" }}
                  center={{ lat: parseFloat(selectedAlert.latitude), lng: parseFloat(selectedAlert.longitude) }}
                  zoom={15}
                >
                  <Marker position={{ lat: parseFloat(selectedAlert.latitude), lng: parseFloat(selectedAlert.longitude) }} />
                </GoogleMap>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default AlertHistory;
